export default __webpack_public_path__ + "static/media/expand-icon.72891e6b.svg";